import { render, staticRenderFns } from "./EquipmentView.vue?vue&type=template&id=70cf1af4&"
import script from "./EquipmentView.vue?vue&type=script&lang=js&"
export * from "./EquipmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports